import { Badge, Div, Flex, Icon, P, Space } from '@dnb/eufemia';
import { cloud as CloudIcon, hourglass as HourglassIcon, stop as StopIcon } from '@dnb/eufemia/icons';
import { Decision } from '@portals/shared/portal/AppApiEntitlementDto';
import classNames from 'classnames';
import type { JSX, ReactNode } from 'react';

import Divider from '@/components/Divider';

import style from './index.module.css';

const getIcon = (status: Decision) => {
  switch (status) {
    case Decision.PENDING: {
      return <HourglassIcon />;
    }
    case Decision.APPROVED: {
      return <CloudIcon />;
    }
    case Decision.DENIED: {
      return <StopIcon />;
    }
    default: {
      return <HourglassIcon />;
    }
  }
};

type ScopeCardProps = {
  scopeId: string;
  scopeName: string;
  scopeDescription: string;
  showAccessSection?: boolean;
  reviewStatus?: Decision;
  environments: string[];
  deleteAction?: ReactNode;
};

export default function ScopeCard({
  scopeId,
  scopeName,
  scopeDescription,
  showAccessSection = true,
  reviewStatus = Decision.APPROVED,
  environments,
  deleteAction,
}: ScopeCardProps): JSX.Element {
  return (
    <Div>
      <Flex.Container align="center" justify="space-between" key={scopeId} wrap={false}>
        <Flex.Item>
          <span className={classNames(style['Icon'], style[`Icon--${reviewStatus.toLowerCase()}`])}>
            <Icon icon={getIcon(reviewStatus)} />
          </span>
        </Flex.Item>
        <Flex.Item grow>
          <div>
            <P weight="medium">{scopeName}</P>
            <P size="small">{scopeDescription}</P>
          </div>
        </Flex.Item>
        {showAccessSection && environments && (
          <div className="grid grid-cols-[2.6rem_2.6rem] gap-2">
            {environments.includes('Test') && <Badge className="col-start-1" content="Test" />}
            {environments.includes('Live') && <Badge className="col-start-2" content="Live" status="positive" />}
          </div>
        )}
        {deleteAction && <Flex.Item>{deleteAction}</Flex.Item>}
      </Flex.Container>
      <Space bottom="small" top="small">
        <Divider />
      </Space>
    </Div>
  );
}
